const NotFound = () => {
  return (
    <div className="h-screen w-screen flex justify-center items-center font-extrabold text-3xl">
      この画面はアクセス権限がありません。
    </div>
  );
};

export default NotFound;
